import { HiOutlineDocumentText } from 'react-icons/hi';
import { ChatItemCreateController } from './chatCreateInterface';
import { BsFileEarmarkDiff } from 'react-icons/bs';

export function createChatItemCreateController(): ChatItemCreateController {
    return {
        useProps(context, item, props) {
            return {
                label: 'Created document',
                Icon: BsFileEarmarkDiff,
                document: {
                    label: item.content?.title ?? 'Content no longer available',
                    icon: item.content?.icon
                        ? {
                              kind: 'emoji',
                              text: item.content.icon,
                          }
                        : {
                              kind: 'icon',
                              Component: HiOutlineDocumentText,
                          },
                    onClick() {
                        props.onOpen();
                    },
                },
                blocks: {
                    visualization: {
                        size: Math.min(item.tool.args.blocks.length, 3),
                    },
                    added: {
                        label: `+${item.tool.args.blocks.length}`,
                        value: item.tool.args.blocks.length,
                    },
                },
            };
        },
    };
}
